import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, ListItem, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { CustomSVG, Numeric } from 'components';
import { useCurrentUser, useClient } from 'hooks';
import { people as peoplePath } from 'paths';
import { generateLink, People } from 'Links';

import styles from './itemStyles';

const ClientFollowers: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { t } = useTranslation();
  const { title } = useClient();
  const { id, follower_count } = useCurrentUser();

  function renderFollowers() {
    if (!follower_count) {
      return (
        <Link component={People} color="textSecondary">
          {t('components:findPeople')}
        </Link>
      );
    }

    return (
      <Link component={generateLink(`/profile/${id}/followers`)} color="textSecondary">
        <Numeric value={follower_count} />
      </Link>
    );
  }

  return (
    <ListItem disableGutters>
      <CustomSVG name="everyoneSocial" className={classes.companyIcon} />
      <ListItemText disableTypography>
        <Link variant="body2" component={generateLink(peoplePath)}>
          {title}
        </Link>
      </ListItemText>
      <ListItemSecondaryAction>{renderFollowers()}</ListItemSecondaryAction>
    </ListItem>
  );
};

export default withStyles(styles)(ClientFollowers);
